(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-articles"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    new Ajaxinate({
      container: '#article-loop',
      pagination: '#article-pagination',
      method: 'click',
      loadingText: 'Loading...',
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    new Ajaxinate({
      container: '#product-loop',
      pagination: '#product-pagination',
      method: 'click',
      loadingText: 'Loading...',
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.getElementById('header');
  const mainMenu = document.getElementById('main-menu');
  const sideMenu = document.getElementById('side-menu');
  const sideMenuButton = document.getElementById('side-menu-button');

  // Show/hide child menu on hover.
  const initHoverEvents = (menuItem) => {
    const childMenu = menuItem.querySelector('&>div');

    var hideTimeout;

    const showChildren = () => {
      clearTimeout(hideTimeout);

      childMenu.classList.add('opacity-100');
      childMenu.classList.add('pointer-events-auto');
      childMenu.classList.remove('pointer-events-none');

      // Hide other children.
      Array.from(mainMenu.querySelectorAll('li>div')).forEach((child) => {
        if (child !== childMenu) {
          child.classList.remove('opacity-100');
          child.classList.remove('pointer-events-auto');
          child.classList.add('pointer-events-none');
        }
      });
    };

    const hideChildren = () => {
      hideTimeout = setTimeout(() => {
        childMenu.classList.remove('opacity-100');
        childMenu.classList.remove('pointer-events-auto');
        childMenu.classList.add('pointer-events-none');
      }, 300);
    };

    menuItem.addEventListener('mouseenter', showChildren);
    menuItem.addEventListener('mouseleave', hideChildren);
  };

  // Toggle side menu visibility.
  const toggleSideMenu = () => {
    const active = sideMenu.classList.contains('opacity-100');

    if (active) {
      document.body.classList.remove('overflow-hidden');

      header.classList.remove('z-50');

      sideMenu.classList.remove('opacity-100');
      sideMenu.classList.remove('pointer-events-auto');
      sideMenu.classList.add('pointer-events-none');
    } else {
      document.body.classList.add('overflow-hidden');

      header.classList.add('z-50');

      sideMenu.classList.add('opacity-100');
      sideMenu.classList.add('pointer-events-auto');
      sideMenu.classList.remove('pointer-events-none');
    }

    // Toggle button icon.
    sideMenuButton.querySelectorAll('&>span').forEach((icon) => {
      icon.classList.toggle('hidden');
    });
  };

  // Toggle child menu visibility in side menu.
  const toggleSideMenuChildMenu = (button) => {
    const menuItem = button.parentElement.parentElement;
    const childMenu = menuItem.querySelector('ul');
    const childMenuWrapper = childMenu.parentElement;
    const active = childMenuWrapper.style.height !== '';

    if (active) {
      childMenuWrapper.style.height = '';
      button.textContent = '↓';
    } else {
      childMenuWrapper.style.height = childMenu.offsetHeight + 'px';
      button.textContent = '↑';
    }
  };

  // For all menu items with children, initialize hover events.
  mainMenu.querySelectorAll('&>li').forEach((menuItem) => {
    if (menuItem.querySelector('&>div')) {
      initHoverEvents(menuItem);
    }
  });

  // Toggle side menu visibility on button click.
  sideMenuButton.addEventListener('click', toggleSideMenu);

  // Toggle side menu child menu visibility on button click.
  sideMenu.querySelectorAll('button').forEach((button) => {
    button.addEventListener('click', () => toggleSideMenuChildMenu(button));
  });

  // If an anchor link is clicked in the side menu, close the side menu.
  sideMenu.querySelectorAll('a').forEach((link) => {
    if (link.href.startsWith(window.location.href.replace(/#.*$/, '') + '#')) {
      link.addEventListener('click', toggleSideMenu);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-or-video"]) return;
  try {
    
  const videoWrapper = document.getElementById('video-wrapper');

  // Handle video appearance based on play/pause state.
  if (videoWrapper) {
    const playButton = videoWrapper.querySelector('button');
    const video = videoWrapper.querySelector('video');

    const handleFullscreenChange = () => {
      if (document.fullscreenElement) {
        video.classList.remove('object-cover');
        video.classList.add('object-contain');
      } else {
        video.classList.remove('object-contain');
        video.classList.add('object-cover');
      }
    };

    const handlePauseChange = () => {
      if (video.paused) {
        playButton.classList.remove('hidden');
        video.controls = false;
      } else {
        playButton.classList.add('hidden');
        video.controls = true;
      }
    };

    playButton.addEventListener('click', () => video.play());

    video.addEventListener('pause', handlePauseChange);
    video.addEventListener('play', handlePauseChange);

    video.addEventListener('fullscreenchange', handleFullscreenChange);
    video.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    video.addEventListener('mozfullscreenchange', handleFullscreenChange);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const productImageCarousel = document.getElementById('product-image-carousel');
  const previousImageButton = document.getElementById('previous-image-button');
  const nextImageButton = document.getElementById('next-image-button');
  const productDetails = document.getElementById('product-details');

  // Scrolls the image carousel in the given direction (-1 for left, 1 for right).
  const scrollImageCarousel = (direction) => {
    const imageWidth = productImageCarousel.firstElementChild.getBoundingClientRect().width;

    productImageCarousel.scrollBy({
      left: direction * imageWidth,
      behavior: 'smooth',
    });
  };

  // Updates the visibility of the previous/next image buttons based on the scroll position of the image carousel.
  const scrollButtonVisibility = () => {
    const scrollLeft = productImageCarousel.scrollLeft;
    const scrollWidth = productImageCarousel.scrollWidth;
    const clientWidth = productImageCarousel.clientWidth;

    if (scrollLeft === 0) {
      previousImageButton.classList.add('opacity-0', 'pointer-events-none');
    } else {
      previousImageButton.classList.remove('opacity-0', 'pointer-events-none');
    }

    if (scrollLeft + clientWidth >= scrollWidth) {
      nextImageButton.classList.add('opacity-0', 'pointer-events-none');
    } else {
      nextImageButton.classList.remove('opacity-0', 'pointer-events-none');
    }
  };

  // Toggle product details controls visibility.
  const toggleProductDetailsControls = (button, icon, detailsWrapper, details, gradient) => {
    const active = detailsWrapper.style.height !== '';
    const overflowing = details.offsetHeight > detailsWrapper.offsetHeight;

    if (overflowing) {
      button.classList.add('cursor-pointer');
      icon.classList.remove('hidden');
      gradient.classList.remove('hidden');
    } else {
      button.classList.remove('cursor-pointer');
      detailsWrapper.classList.add('max-h-[4lh]');
      detailsWrapper.classList.remove('h-[4lh]');
      icon.classList.add('hidden');
      gradient.classList.add('hidden');
    }
  };

  // Toggle product details visibility.
  const toggleProductDetails = (buttonHeader, icon, detailsWrapper, details, gradient) => {
    const active = detailsWrapper.style.height !== '';
    const overflowing = details.offsetHeight > detailsWrapper.offsetHeight;

    if (active) {
      detailsWrapper.style.height = '';
      icon.classList.remove('rotate-45');
      gradient.classList.remove('hidden');
    } else if (overflowing) {
      detailsWrapper.classList.add('h-[4lh]');
      detailsWrapper.classList.remove('max-h-[4lh]');
      detailsWrapper.style.height = details.offsetHeight + 'px';
      icon.classList.add('rotate-45');
      gradient.classList.add('hidden');
    }
  };

  // Update scroll button visibility on image carousel scroll.
  productImageCarousel.addEventListener('scroll', scrollButtonVisibility);

  // When clicking the previous/next image buttons, scroll the image carousel.
  if (previousImageButton && nextImageButton) {
    previousImageButton.addEventListener('click', () => scrollImageCarousel(-1));
    nextImageButton.addEventListener('click', () => scrollImageCarousel(1));
  }

  // Init product details functionality.
  productDetails.querySelectorAll('button').forEach((button) => {
    const buttonHeader = button.firstElementChild;
    const icon = buttonHeader.lastElementChild;
    const detailsWrapper = buttonHeader.nextElementSibling;
    const details = detailsWrapper.firstElementChild;
    const gradient = detailsWrapper.lastElementChild;

    toggleProductDetailsControls(button, icon, detailsWrapper, details, gradient);

    button.addEventListener('click', () => toggleProductDetails(buttonHeader, icon, detailsWrapper, details, gradient));
    window.addEventListener('resize', () =>
      toggleProductDetailsControls(button, icon, detailsWrapper, details, gradient)
    );
  });

  } catch(e) { console.error(e); }
})();
})();
